/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function () {
        $(document).ready(function() {
          $("#tabs").tabs({
            active: 0,
          });
        });
        
        // JavaScript to be fired on all pages
        /** Site Promotion */

        function site_promotion(enabled) {
          var now = new Date();
          var expiryDate = now.setDate(now.getDate() + 1);
          now.setTime(expiryDate);

          if (enabled === false) {
            $('.site-promotion').addClass('hidden-promo');
            document.cookie = 'site_promotion=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
          }

          if (enabled === true) {
            $('.site-promotion').removeClass('hidden-promo');
            document.cookie = 'site_promotion=false;expires=' + now.toGMTString() + ';path=/';
          }

        }

        $('.site-promotion .hidepromo').on('click', function () {
          site_promotion(false);
        });

        $('.site-promotion .open').on('click', function () {
          site_promotion(true);
        });

        if (document.cookie.indexOf('site_promotion=') === -1) {
          $('.site-promotion').removeClass('hidden-promo');
        }


        $(".grid").masonry({
          itemSelector: ".grid-item",
          columnWidth: ".grid-sizer",
          percentPosition: true,
          //fitwidth: true,
          gutter: 15
        });

        $.ajax({
          method: "GET",
          url: "https://store.nbninternational.com/checkout/?lang=en&pub=089&response=json",
          dataType: "json",
          success: function (response) {
            console.log(response);
          }
        });

        /* ---- Custom Search ---- */
        if ($("#ptype").val() === "author" || $("#ptype").val() === "journal") {
          $("#wpas-meta_type_abbreviation input").attr("checked", false);
          $("#wpas-meta_ean_code input").attr("value", "");
          $("#wpas-meta_type_abbreviation").hide();
          $("#wpas-meta_ean_code").hide();
        } else {
          $("#wpas-meta_type_abbreviation").show();
          $("#wpas-meta_ean_code").show();
        }
        $("#ptype").on("change", function () {
          if ($("#ptype").val() === "author" || $("#ptype").val() === "journal") {
            $("#wpas-meta_type_abbreviation input").attr("checked", false);
            $("#wpas-meta_ean_code input").attr("value", "");
            $("#wpas-meta_type_abbreviation").hide();
            $("#wpas-meta_ean_code").hide();
          } else {
            $("#wpas-meta_type_abbreviation").show();
            $("#wpas-meta_ean_code").show();
          }
        });
        /* ---- END Custom Search ---- */

        $(".ebook-dropdown").dropdown();

        /* ---- Email Subscribe ---- */
        //english
        $('.english-email-subscribe .mc4wp-form input[type="submit"]').val("Sign up");
        $('.english-email-subscribe .mc4wp-form input[type="email"]').attr("placeholder", "email address");
        //welsh
        $('.welsh-email-subscribe .mc4wp-form input[type="submit"]').val("Cofrestru");
        $('.welsh-email-subscribe .mc4wp-form input[type="email"]').attr("placeholder", "cyfeiriad e-bost");
        /* ---- Email Subscribe END ---- */

        /* ---- HEADER SEARCH FUNCTIONALITY ---- */
        $("#header-search-form .checkbox .styledCheckbox").on("click", function () {
          var english = $("#header-search-form #englishCheck");
          var welsh = $("#header-search-form #welshCheck");
          var setLang = $("#header-search-form .search-lang");
          var isbn = $("#header-search-form #isbnCheck");
          var isbnCheck = $("#header-search-form .isbn-check");

          if ($(isbn).attr("checked")) {
            $(isbnCheck).val("true");
          } else {
            $(isbnCheck).val("false");
          }

          if ($(welsh).attr("checked") && $(english).attr("checked")) {
            $(setLang).val("en-cy");
          } else {
            if ($(welsh).attr("checked")) {
              $(setLang).val("cy");
            }
            if ($(english).attr("checked")) {
              $(setLang).val("en");
            }
          }
        });

        // Keep search options checked afer reload.
        const params = new URL(document.location).searchParams;

        var all = params.get("generic[]");

        if (all != null) {
          $("#wpas-generic-checkbox-").attr("checked", true);
        }

        var hardback = params.get("meta_is_hardback[]");

        if (hardback != null) {
          $("#wpas-generic-checkbox-").attr("checked", false);
          $("#wpas-meta_is_hardback-checkbox-").attr("checked", true);
        }

        var paperback = params.get("meta_is_paperback[]");

        if (paperback != null) {
          $("#wpas-generic-checkbox-").attr("checked", false);
          $("#wpas-meta_is_paperback-checkbox-").attr("checked", true);
        }

        var eMobi = params.get("meta_is_eMobi[]");

        if (eMobi != null) {
          $("#wpas-generic-checkbox-").attr("checked", false);
          $("#wpas-meta_is_eMobi-checkbox-").attr("checked", true);
        }

        var ePub = params.get("meta_is_ePub[]");

        if (ePub != null) {
          $("#wpas-generic-checkbox-").attr("checked", "");
          $("#wpas-meta_is_ePub-checkbox-").attr("checked", true);
        }

        var ePDF = params.get("meta_is_ePDF[]");

        if (ePDF != null) {
          $("#wpas-generic-checkbox-").attr("checked", false);
          $("#wpas-meta_is_ePDF-checkbox-").attr("checked", true);
        }

        var ESO = params.get("meta_is_ESO[]");

        if (ESO != null) {
          $("#wpas-generic-checkbox-").attr("checked", false);
          $("#wpas-meta_is_ESO-checkbox-").attr("checked", true);
        }
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        /* ---- Content functionality ---- */
        var aboutHeight = $(".main .section.about").height();
        var contentsHeight = $(".main .section.contents").height();
        var endorsementHeight = $(".main .section.endorsements").height();

        if (aboutHeight > 200) {
          //console.log(aboutHeight);
          $(".main .section.about").addClass("inactive");
          if ($("body").hasClass("lng-en")) {
            $(".main .section.about").after(
              '<p class="show-more-about" data-ref=".section.about"><i class="fa fa-plus" aria-hidden="true"></i> Read more</p>'
            );
          } else {
            $(".main .section.about").after(
              '<p class="show-more-about" data-ref=".section.about"><i class="fa fa-plus" aria-hidden="true"></i> Darllen mwy</p>'
            );
          }
          $("p.show-more-about").on("click", function () {
            var expandTarget = $(this).attr("data-ref");
            $(this).toggleClass("active");
            $(expandTarget).toggleClass("active");
            $(expandTarget).toggleClass("inactive");
            if ($("body").hasClass("lng-en") && $(this).hasClass("active")) {
              $(this).html('<i class="fa fa-minus" aria-hidden="true"></i> Read less');
            } else if ($("body").hasClass("lng-cy") && $(this).hasClass("active")) {
              $(this).html('<i class="fa fa-minus" aria-hidden="true"></i> Darllenwch llai');
            } else if ($("body").hasClass("lng-cy") && !$(this).hasClass("active")) {
              $(this).html('<i class="fa fa-minus" aria-hidden="true"></i> Darllen mwy');
            } else if ($("body").hasClass("lng-en") && !$(this).hasClass("active")) {
              $(this).html('<i class="fa fa-plus" aria-hidden="true"></i> Read more');
            } else {
            }
          });
        }

        if (contentsHeight > 200) {
          //console.log(aboutHeight);
          $(".main .section.contents").addClass("inactive");
          if ($("body").hasClass("lng-en")) {
            $(".main .section.contents").after(
              '<p class="show-more-contents" data-ref=".section.contents"><i class="fa fa-plus" aria-hidden="true"></i> Read more</p>'
            );
          } else {
            $(".main .section.contents").after(
              '<p class="show-more-contents" data-ref=".section.contents"><i class="fa fa-plus" aria-hidden="true"></i> Darllen mwy</p>'
            );
          }
          $("p.show-more-contents").on("click", function () {
            var expandTarget = $(this).attr("data-ref");
            $(this).toggleClass("active");
            $(expandTarget).toggleClass("active");
            $(expandTarget).toggleClass("inactive");
            if ($("body").hasClass("lng-en") && $(this).hasClass("active")) {
              $(this).html('<i class="fa fa-plus" aria-hidden="true"></i> Read more');
            } else if ($("body").hasClass("lng-cy") && $(this).hasClass("active")) {
              $(this).html('<i class="fa fa-minus" aria-hidden="true"></i> Darllen mwy');
            } else if ($("body").hasClass("lng-cy") && !$(this).hasClass("active")) {
              $(this).html('<i class="fa fa-minus" aria-hidden="true"></i> Darllenwch llai');
            } else if ($("body").hasClass("lng-en") && !$(this).hasClass("active")) {
              $(this).html('<i class="fa fa-minus" aria-hidden="true"></i> Read less');
            } else {
            }
          });
        }

        if (endorsementHeight > 200) {
          //console.log(aboutHeight);
          $(".main .section.endorsements").addClass("inactive");
          if ($("body").hasClass("lng-en")) {
            $(".main .section.endorsements").after(
              '<p class="show-more-endorsements" data-ref=".section.endorsements"><i class="fa fa-plus" aria-hidden="true"></i> Read more</p>'
            );
          } else {
            $(".main .section.endorsements").after(
              '<p class="show-more-endorsements" data-ref=".section.endorsements"><i class="fa fa-plus" aria-hidden="true"></i> Darllen mwy</p>'
            );
          }
          $("p.show-more-endorsements").on("click", function () {
            var expandTarget = $(this).attr("data-ref");
            $(this).toggleClass("active");
            $(expandTarget).toggleClass("active");
            $(expandTarget).toggleClass("inactive");
            if ($("body").hasClass("lng-en") && $(this).hasClass("active")) {
              $(this).html('<i class="fa fa-plus" aria-hidden="true"></i> Read more');
            } else if ($("body").hasClass("lng-cy") && $(this).hasClass("active")) {
              $(this).html('<i class="fa fa-minus" aria-hidden="true"></i> Darllen mwy');
            } else if ($("body").hasClass("lng-cy") && !$(this).hasClass("active")) {
              $(this).html('<i class="fa fa-minus" aria-hidden="true"></i> Darllenwch llai');
            } else if ($("body").hasClass("lng-en") && !$(this).hasClass("active")) {
              $(this).html('<i class="fa fa-minus" aria-hidden="true"></i> Read less');
            } else {
            }
          });
        }
        /* ---- Content functionality END ---- */
      }
    },
    // Home page
    home: {
      init: function () {
        // JavaScript to be fired on the home page
        /* ---- BOOK SLIDER FEED ---- */
        $("#bookSlider").slick({
          speed: 500,
          fade: true,
          arrows: false,
          cssEase: "linear",
          dots: true,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 6000
        });
        /* ---- BOOK SLIDER FEED END ---- */
        /* ---- FEATURED TITLES SLIDER ---- */
        $("#ftSlider").slick({
          infinite: true,
          slidesToShow: 4,
          dots: true,
          slidesToScroll: 4,
          responsive: [
            {
              breakpoint: 991,
              settings: {
                arrows: false,
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 500,
              settings: {
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });

        $("#ftJournalSlider").slick({
          infinite: true,
          slidesToShow: 4,
          dots: true,
          slidesToScroll: 4,
          responsive: [
            {
              breakpoint: 991,
              settings: {
                arrows: false,
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 500,
              settings: {
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
        /* ---- FEATURED TITLES SLIDER FEED ---- */

      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    about_us: {
      init: function () {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, "_").split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, "finalize");
      });

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    },

    
  };

  
  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
